<h2 mat-dialog-title>Conferma Eliminazione</h2>
<mat-dialog-content>
  <p>Sei sicuro di voler rimuovere questo elemento?</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Annulla</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Conferma</button>
</mat-dialog-actions>
